import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, ArrowUpRight } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

const Footer = () => {
  const scrollToContact = (e) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#042F2E] text-white" data-testid="footer">
      <div className="container-grid py-16 sm:py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12">
          {/* Brand */}
          <div className="md:col-span-4">
            <div className="flex items-center gap-2.5 mb-5">
              <div className="h-9 w-9 rounded-lg bg-white/10 flex items-center justify-center">
                <span className="text-white font-bold text-lg font-heading">G</span>
              </div>
              <span className="text-xl font-semibold font-heading tracking-tight">Growartha</span>
            </div>
            <p className="text-sm text-white/50 leading-relaxed max-w-xs">
              Empowering startups with expert CA services. Compliance made simple, so you can focus on growing your business.
            </p>
          </div>

          {/* Services */}
          <div className="md:col-span-2">
            <h4 className="font-body font-semibold mb-5 text-xs uppercase tracking-[0.2em] text-white/40">Services</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li><Link to="/services" className="hover:text-white transition-colors duration-200">GST Returns</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors duration-200">Income Tax</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors duration-200">TDS Returns</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors duration-200">Audit</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors duration-200">ROC Compliance</Link></li>
            </ul>
          </div>

          {/* Quick Links */}
          <div className="md:col-span-2">
            <h4 className="font-body font-semibold mb-5 text-xs uppercase tracking-[0.2em] text-white/40">Company</h4>
            <ul className="space-y-3 text-sm text-white/60">
              <li><Link to="/" className="hover:text-white transition-colors duration-200">Home</Link></li>
              <li><a href="#contact" onClick={scrollToContact} className="hover:text-white transition-colors duration-200 cursor-pointer">Contact</a></li>
              <li><Link to="/login" className="hover:text-white transition-colors duration-200">Client Login</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div className="md:col-span-4">
            <h4 className="font-body font-semibold mb-5 text-xs uppercase tracking-[0.2em] text-white/40">Get In Touch</h4>
            <ul className="space-y-4 text-sm text-white/60">
              <li className="flex items-center gap-3">
                <div className="h-8 w-8 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                  <Mail className="h-3.5 w-3.5" />
                </div>
                info@growartha.com
              </li>
              <li className="flex items-center gap-3">
                <div className="h-8 w-8 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                  <Phone className="h-3.5 w-3.5" />
                </div>
                +91-9999999999
              </li>
              <li className="flex items-center gap-3">
                <div className="h-8 w-8 rounded-full bg-white/5 flex items-center justify-center flex-shrink-0">
                  <MapPin className="h-3.5 w-3.5" />
                </div>
                Mumbai, Maharashtra
              </li>
            </ul>
          </div>
        </div>

        <Separator className="my-10 bg-white/10" />

        <div className="flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-white/30">
          <p>&copy; {new Date().getFullYear()} Growartha. All rights reserved.</p>
          <a
            href="#contact"
            onClick={scrollToContact}
            className="flex items-center gap-1 text-white/50 hover:text-white transition-colors duration-200 cursor-pointer"
          >
            Start a conversation <ArrowUpRight className="h-3 w-3" />
          </a>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
